function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M95.07 41.923H6.93a4.008 4.008 0 01-4.007-4.006A4.008 4.008 0 016.93 33.91H95.07a4.008 4.008 0 014.007 4.007 4.008 4.008 0 01-4.007 4.006zM95.07 11.207H6.93a4.008 4.008 0 01-4.007-4.006A4.008 4.008 0 016.93 3.194H95.07a4.008 4.008 0 014.007 4.007 4.008 4.008 0 01-4.007 4.006zM95.07 72.638H6.93a4.008 4.008 0 01-4.007-4.006 4.008 4.008 0 014.006-4.006H95.07a4.008 4.008 0 014.007 4.006 4.008 4.008 0 01-4.007 4.006z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 5
});

var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 102 76",
    fill: "none"
  }, props), _ref);
};

export default SvgMenu;